/* Keto Hana — request right-sized card images from Shopify's CDN so large
   product photos don't get softly downscaled by the browser in the bundle grid. */
(function () {
  var W = 800;
  function fix(scope) {
    (scope || document).querySelectorAll('.bundle-v2__card-image img').forEach(function (img) {
      if (img.dataset.hires) return;
      var s = img.getAttribute('src') || '';
      if (!s) { return; }
      try {
        var u = new URL(s, window.location.origin);
        if (u.hostname.indexOf('shopify') !== -1) {
          u.pathname = u.pathname.replace(/_(\d+)x(\d+)?(?=\.[a-zA-Z]+(?:$|\?))/, '');
          u.searchParams.set('width', W);
          img.setAttribute('src', u.toString());
        }
        img.dataset.hires = '1';
      } catch (e) {}
    });
  }
  function boot() {
    var host = document.querySelector('.bundle-v2 [data-products]');
    if (host) new MutationObserver(function () { fix(document); }).observe(host, { childList: true, subtree: true });
    fix(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
